var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6322 24.4043C14.7173 24.4043 17.6761 23.14 19.8577 20.8896C22.0392 18.6391 23.2648 15.5869 23.2648 12.4043C23.2648 9.2217 22.0392 6.16945 19.8577 3.91902C17.6761 1.66858 14.7173 0.404297 11.6322 0.404297C8.54699 0.404297 5.58818 1.66858 3.40664 3.91902C1.22509 6.16945 -0.000488281 9.2217 -0.000488281 12.4043C-0.000488281 15.5869 1.22509 18.6391 3.40664 20.8896C5.58818 23.14 8.54699 24.4043 11.6322 24.4043Z",
    fill: "#1377D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72412 15.4721V9.33649C8.72412 8.62693 9.52323 8.17824 10.174 8.52258L15.9751 11.5921C16.1251 11.6641 16.2521 11.7787 16.3411 11.9226C16.43 12.0665 16.4773 12.2336 16.4773 12.4043C16.4773 12.575 16.43 12.7421 16.3411 12.886C16.2521 13.0298 16.1251 13.1445 15.9751 13.2165L10.1757 16.286C9.52323 16.6304 8.72412 16.1817 8.72412 15.4721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconActive);
export default __webpack_public_path__ + "static/media/video-icon-active.1f0e2a7719b1ef342910126337d7eb62.svg";
export { ForwardRef as ReactComponent };